/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// nodejs library that concatenates strings
import classnames from "classnames";

// reactstrap components
import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
} from "reactstrap";

import { FaBlogger, FaDownload, FaInstagram, FaLinkedin, FaPatreon, FaPaypal, FaYoutube, FaGlobe } from "react-icons/fa";

function HomeNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 299 ||
        document.body.scrollTop > 299
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 300 ||
        document.body.scrollTop < 300
      ) {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <Navbar className={classnames("fixed-top", navbarColor)} expand="lg">
      <Container>
        <div className="navbar-translate">
          <NavbarBrand style={{ paddingLeft: '66px', paddingTop: '10px' }}
            data-placement="bottom"
            href='/mkdote/'
            title="MKDOTE Navbar"
          >
            <h1 style={{ marginTop: '0px' }} >@</h1>
            <h4 style={{ marginTop: '-45px', marginLeft: '-45px' }}> M K </h4>
            <h4 style={{ marginTop: '-27px', marginLeft: '55px' }}> D O T E </h4>
          </NavbarBrand>
          <button
            aria-expanded={navbarCollapse}
            className={classnames("navbar-toggler navbar-toggler", {
              toggled: navbarCollapse,
            })}
            onClick={toggleNavbarCollapse}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>
        <Collapse
          className="justify-content-end"
          navbar
          isOpen={navbarCollapse}
        >
          <Nav navbar>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://www.youtube.com/channel/UCmlmsLb9LyH3K9axEmq0MNA"
                target="_blank"
                title="Subscribe to my YouTube channel"
              >
                <FaYoutube size="20px" />
                <p className="d-lg-none" style={{ marginLeft: '20px' }} > YouTube </p>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://www.linkedin.com/in/danilo-abell%C3%A1-b98535142/"
                target="_blank"
                title="Contact me on Linkedin"
              >
                <FaLinkedin size="20px" />
                <p className="d-lg-none" style={{ marginLeft: '20px' }} > Linkedin </p>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://www.instagram.com/daniloabella24/"
                target="_blank"
                title="Follow me on Instagram"
              >
                <FaInstagram size="20px" />
                <p className="d-lg-none" style={{ marginLeft: '20px' }} > Instagram </p>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://mkdefenderearth.blogspot.com/"
                target="_blank"
                title="Visit the Blog"
              >
                <FaBlogger size="20px" />
                <p className="d-lg-none" style={{ marginLeft: '20px' }} > Blogger </p>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://www.patreon.com/daniloabella"
                target="_blank"
                title="Donate on Patreon"
              >
                <FaPatreon size="20px" />
                <p className="d-lg-none" style={{ marginLeft: '20px' }} > Patreon </p>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://www.paypal.com/donate?hosted_button_id=2GRV5G6UELHPL"
                target="_blank"
                title="Donate me in PayPal"
              >
                <FaPaypal size="20px" />
                <p className="d-lg-none" style={{ marginLeft: '20px' }} > Paypal </p>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://daniloabella.com"
                title="Danilo´s personal website"
              >
                <FaGlobe size="20px" />
                <p className="d-lg-none" style={{ marginLeft: '20px' }} > Paypal </p>
              </NavLink>
            </NavItem>
            <NavItem>
              <Button
                style={{ marginLeft: '18px' }}
                className="btn"
                color="info"
                target="_blank"
                href="https://daniloabella.gamejolt.io/MKDE"
              >
                <FaDownload size="16px" style={{ marginRight: '10px' }} />
                Download
              </Button>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default HomeNavbar;
